import HeroSection from "../../components/sections/HeroSection";
import PreviewGallerySection from "../../components/sections/PreviewGallerySection";
import "./HomePage.css";

function HomePage() {
  return (
    <div className="home-page">
      <HeroSection />
      <PreviewGallerySection />
    </div>
  );
}

export default HomePage;
